import { render, staticRenderFns } from "./Deliberation.vue?vue&type=template&id=ed7618a2&"
import script from "./Deliberation.vue?vue&type=script&lang=js&"
export * from "./Deliberation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports